/**
* mapConstants.ts
* Список констант для использования в карте.
**/

import {fromLonLat, transformExtent} from "ol/proj";

// Ограничение размеров карты. (ol/extent)
const MAP_EXTENT_WGS84 = [19.0, 41.0, 180.0, 82.0];
export const MAP_EXTENT = transformExtent(MAP_EXTENT_WGS84, "EPSG:4326", "EPSG:3857");

// Значение центра карты по умолчанию.
export const INITIAL_CENTER = fromLonLat([130, 69]);

// Значение зума карты по умолчанию
export const INITIAL_ZOOM = 3.2;

// Конфигурация квадрата расположенного на карте с данными региона/округа.
export const SQUARE_CONFIG = {
    size: 60,
    squareSize: 48,
    borderRadius: 8,
    shadowColor: "rgba(128, 128, 128, 0.3)",
    shadowBlur: 11,
    shadowOffsetX: 1.1,
    shadowOffsetY: 2.2,
    hitTolerance: 24,
    strokeColor: "#FFFFFF",
    strokeWidth: 1,
    textColor: "#FFFFFF",
    boldFont: "bold 13px Roboto",
    regularFont: "11px Roboto"
} as const;

// Предопределенные координаты центров для округов. [lon, lat] в WGS84
export const DISTRICT_CENTER_OVERRIDES: Record<string, [number, number]> = {
    central: [37.5000, 54.9776],
    northwestern: [45.8100, 64.0551],
    southern: [42.8613, 47.7245],
    north_caucasian: [44.7949, 43.9295],
    volga: [52.0140, 56.1698],
    ural: [71.1621, 63.2336],
    siberian: [96.5625, 65.6220],
    far_eastern: [144.1992, 65.4400],
};

// Предопределенные значения зума для округов.
export const DISTRICT_ZOOM_OVERRIDES: Record<string, number> = {
    central: 6,
    northwestern: 5,
    southern: 6,
    north_caucasian: 7,
    volga: 6,
    ural: 5,
    siberian: 4,
    far_eastern: 4,
};

// Предопределенные координаты центров для регионов [lon, lat] в WGS84
export const REGION_CENTER_OVERRIDES: Record<string, [number, number]> = {
    adygea: [40.1851, 44.5603],
    arkhangelsk: [43.5167, 64.5333],
    astrakhan: [47.9592, 46.9359],
    belgorod: [37.9827, 50.7891],
    buryatia: [111.5918, 54.1109],
    chelyabinsk: [61.0117, 55.0660],
    chukotka: [170.0000, 67.2026],
    dagestan: [47.1402, 42.4138],
    ingushetia: [44.9875, 43.2454],
    kaliningrad: [20.5100, 54.7100],
    kalmykia: [45.5942, 46.4667],
    kamchatka: [160.0000, 57.2026],
    krasnodar: [39.5586, 45.7633],
    khabarovsk: [136.5277, 51.0280],
    khanty_mansi: [68.9871, 61.8220],
    krasnoyarsk: [96.3867, 66.9301],
    mordovia: [44.3761, 54.1029],
    moscow_oblast: [38.7508, 55.2507],
    nenets: [54.5167, 67.5333],
    north_ossetia: [44.2852, 42.9595],
    novgorod: [32.2400, 58.3125],
    orenburg: [54.4627, 52.0208],
    sakha: [127.1484, 65.5130],
    sakhalin: [143.0000, 50.2026],
    sevastopol: [33.5968, 44.5538],
    tyumen: [68.2178, 57.5544],
    ulyanovsk: [47.8483, 54.0907],
    yamalo_nenets: [75.5167, 65.5333],
    zabaykalsky: [117.0579, 52.3931]
};

// Предопределенные значения зума для регионов.
export const REGION_ZOOM_OVERRIDES: Record<string, number> = {
    adygea: 8,
    belgorod: 8,
    moscow_oblast: 7,
    moscow_city: 8,
    novgorod: 7,
    astrakhan: 7,
    kalmykia: 7,
    kaliningrad: 7,
    sevastopol: 7,
    ingushetia: 8,
    north_ossetia: 8
};